<template>
  <FormContainer :withoutDivider="moduleEnCours?.typeModule === 'Interne'">
    <template #title>Modalité de formation</template>
    <template #content>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_24 field_65"
          :model-value="moduleEnCours?.modalitePedagogique"
          @update:model-value="updateModalitePedagogique($event)"
          label="Modalité pédagogique"
          class="col-8 col-md-12 col-sm-36"
          :items="modaliteItems"
          :required="metaModuleEnCours?.modalitePedagogique?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.modalitePedagogique?.$messageErreurDirty!"
          key-id="code"
          key-label="intitule"
          :readonly
        />
        <WrapperInputNumber
          v-if="metaModuleEnCours?.dureeFoad?.$status !== PropertyStatus.NotPresent"
          id="field_25"
          :model-value="moduleEnCours?.dureeFoad"
          @update:model-value="updateModule('dureeFoad', activeModuleIndex!, $event)"
          label="Durée de la formation à distance"
          class="col-8 col-sm-36"
          placeholder="Heures"
          :required="metaModuleEnCours?.dureeFoad?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.dureeFoad?.$messageErreurDirty!"
          :readonly
          :decimal="2"
        />
        <WrapperInputNumber
          v-else
          id="field_25"
          label="Durée de la formation à distance"
          class="col-8 col-sm-36"
          placeholder="Heures"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { inject, computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/AF'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { FormContainer } from '@/features/interface/demande/shared'
  import { AF_MODULES_ACTIONS } from '../../useModuleActions'

  const store = useDemandeAFStore()
  const { setupArrayUpdaterWithKey, model } = store

  const { moduleEnCours, activeModuleIndex, metaModuleEnCours, updateModalitePedagogique } = inject(AF_MODULES_ACTIONS)!

  const { readonly, lov } = storeToRefs(store)

  const updateModule = setupArrayUpdaterWithKey<ModuleDTO>('formation.modules')

  const modaliteItems = computed(() => {
    if (model?.sousDispositif !== 'Fse' && model?.sousDispositif !== 'FTJ') return lov.value.ModalitePedagogique
    return lov.value.ModalitePedagogique.filter((item) => item.code !== 'Foad')
  })
</script>
